import { combineReducers } from 'redux';

import { CustomBrandSettingEmailAction, reducer as email } from './email/state';
import { CustomBrandSettingKakaoTalkAction, reducer as kakaoTalk } from './kakaoTalk/state';

export type CustomBrandSettingAction =
  | CustomBrandSettingEmailAction
  | CustomBrandSettingKakaoTalkAction;

export const reducer = combineReducers({
  email,
  kakaoTalk,
});
